import MatchType from "./MatchType";

export default class Index {

    constructor(data) {
        this.asia = data.asia;
        this.bs = data.bs;
        this.eu = data.eu;
        this.company_id = data.company_id;
        this.id = data.id;
        this.is_initial = data.is_initial;
        this.match_id = data.match_id;
        this.scores = data.scores;
    }

    geteu = (i) => {
        if (!this.eu || !this.eu[2]) return '';
        let eu = this.eu[2].split(',')
        if (eu.length <= i) return '';
        return eu[i];
    }

    getasia(i) {
        if (!this.asia || !this.asia[2]) return '';
        let asia = this.asia[2].split(',')
        if (asia.length <= i) return '';
        return asia[i];
    }

    getasia1(i, j) {
        if (!this.asia || !this.asia[i]) return '';
        let asia = this.asia[i].split(',')
        if (asia.length <= j) return '';
        return asia[j];
    }

    getbs(i) {
        if (!this.bs || !this.bs[2]) return '';
        let bs = this.bs[2].split(',')
        if (bs.length <= i) return '';
        return bs[i];
    }

    getbs1(i, j) {
        if (!this.bs || !this.bs[i]) return '';
        let bs = this.bs[i].split(',')
        if (bs.length <= j) return '';
        return bs[j];
    }

    getResult = (matchType) => {
        if (matchType == MatchType.FOOTBALL) {
            let s = Number(this.geteu(0));
            let p = Number(this.geteu(1));
            let f = Number(this.geteu(2));
            if (isNaN(s) && isNaN(p) && isNaN(f)) {
                return '';
            }
            if (isNaN(s) || s == 0) {
                s = 1;
            }
            if (isNaN(p) || p == 0) {
                p = 1;
            }
            if (isNaN(f) || f == 0) {
                f = 1;
            }
            let all = (s * p * f) / (s * p + p * f + s * f);
            return (all * 100).toFixed(1) + "%"
        }
        return '';
    }

}
